import React from 'react';
import { useTranslation } from 'react-i18next';
import { VehicleDetail } from '@1po/1po-bff-fe-spec/generated/common/vehicle/VehicleDetail';
import { CopyReferenceWithFeedback, CopySelectionWrapper } from 'components/CopyReferenceFeedback';
import { DocumentationAlertButton } from 'components/DocumentationAlertButton';
import ProductModal from 'components/ProductModal';
import { convertTireItemToTireReference } from 'domains/tires/Tire.mapper';
import { Flex, MarginBox, Text } from 'UI';

interface RefInfoRowProps {
  partNumber: string;
  brandName?: string;
  brandLabel?: string;
  tireReference: ReturnType<typeof convertTireItemToTireReference>;
  vehicleDetail?: VehicleDetail;
}

export const RefInfoRow = ({ partNumber, brandName, brandLabel, tireReference, vehicleDetail }: RefInfoRowProps) => {
  const { t } = useTranslation();

  return (
    <Flex direction="row" align="center">
      <CopySelectionWrapper referenceNumber={partNumber}>
        <ProductModal
          id={'tire-ref-num'}
          triggerComponent={
            <Text type="base" cursor={'pointer'} disableGutter noWrap hoverUnderLine>
              {t('catalog.reference_card.reference_number', 'Ref:')} {partNumber}
            </Text>
          }
          referenceNumber={partNumber}
        />
      </CopySelectionWrapper>

      <MarginBox mx={5}>
        <CopyReferenceWithFeedback referenceNumber={partNumber} />
      </MarginBox>
      {brandName === 'MOTRIO_PNEU' && (
        <DocumentationAlertButton
          reference={tireReference}
          vehicleDetail={vehicleDetail}
          vehicleRegistrationNumber={vehicleDetail?.vrn ?? vehicleDetail?.vehicleKey}
        />
      )}

      {brandLabel && (
        <>
          <MarginBox mr={2} />
          <Text type="base" disableGutter noWrap>
            {`| ${brandLabel}`}
          </Text>
        </>
      )}
    </Flex>
  );
};
